import ProfileResolver from "../components/profile/ViewProfile/ProfileResolver";

function ViewProfile() {
  return <ProfileResolver />;
}

export default ViewProfile;
